/* eslint-disable react/jsx-boolean-value, @typescript-eslint/restrict-template-expressions,
@typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call */
import React, { useState } from 'react';
import {
  TextField, ButtonActionEmphasis, sanitize, Icon, Checkbox, Spinner, ButtonActionDefault,
} from '@honeycomb-npm/honeycomb-react';
import Blade from '../../shared/Blade/Blade';
import { BLADES } from '../../../constants';
import { content } from '../../../utils/contentUtils';
import { validNameRegex, isValidNumber, validbsbRegex } from '../../../utils/valueUtil';
import { analyticsConstants } from '../../../constants/analyticsConstants';

import './AccountDetails.scss';

export interface Props {
  visibility: boolean;
  closeModalOpen: () => void;
  focusDisplay: (blade: string) => void;
  completed: (blade: string) => void;
  formInitialState: any;
  formUpdated: (formInitialState: any) => void;
  formSubmited: (formInitialState: any) => void,
  confirmationModalOpen: () => void;
  confirmationModalData: any;
}

const accountDetails = ({
  visibility, focusDisplay, completed, formInitialState, formUpdated, formSubmited, confirmationModalOpen, confirmationModalData,
}: Props) => {
  const {
    accountInfoTitle, accountInfoDesc, accountInfoDesc2, accountNameLabel, accountNameErrorMsg, bsbLabel, bsbErrorMsg,
    accountNumberLabel, accountNumberErrorMsg, consentLabel, consentErrorMsg, accountDetailsDesc, btnTxt, accountNameHelpText,
  } = content[BLADES.accountDetails];

  const {
    accountName,
    accountNameIsValid,
    bsb,
    bsbIsValid,
    accountNumber,
    accountNumberIsValid,
    isConsent,
  } = formInitialState.formData;

  const { isLoading } = formInitialState;

  const handleChange = (e:any, v:any) => {
    if (!validNameRegex(v)) {
      formUpdated({ ...formInitialState.formData, [e]: v, [`${e}IsValid`]: true });
    }
  };

  const handleNumberChange = (e:any, v:any) => {
    const formatNumber = isValidNumber(v) ? v : '';
    formUpdated({ ...formInitialState.formData, [e]: formatNumber, [`${e}IsValid`]: true });
  };

  const handleCheckbox = (e:any, v: boolean) => {
    formUpdated({ ...formInitialState.formData, [e]: v });
  };

  const sendModalData = (e:any) => {
    handleValidate();
  };

  const handleValidate = () => {
    let userData = formInitialState.formData;
    if (!accountName.trim() || validNameRegex(accountName)) {
      userData = { ...userData, accountNameIsValid: false };
    }
    if (!bsb || !validbsbRegex(bsb)) {
      userData = { ...userData, bsbIsValid: false };
    }
    if (!accountNumber) {
      userData = { ...userData, accountNumberIsValid: false };
    }
    if (!isConsent) {
      userData = { ...userData, isConsent: false };
    }
    formUpdated({ ...formInitialState.formData, ...userData });
    if (userData.accountNameIsValid && userData.bsbIsValid && userData.accountNumberIsValid && userData.isConsent) {
      completed(BLADES.accountDetails);
      const {
        remediationIdIsValid: remIdValid,
        lastNameIsValid: lastNameValid,
        dobIsValid: dobValid,
        accountNameIsValid: accountNameValid,
        bsbIsValid: bsbValid,
        accountNumberIsValid: accountNumberValid,
        isConsent: coscent,
        ...formatData
      } = userData;
      const { dob } = userData;
      const filterData = { ...userData, dob: dob.split('-').reverse().join('/') };
      confirmationModalData(filterData);
      confirmationModalOpen();
    }
  };

  const handleSubmit = () => {
    handleValidate();
  };

  return (
    <Blade
      id={BLADES.accountDetails}
      className="account-details"
      shouldVerticalAlign={true}
      visibility={visibility}
      goToPreviousBladeClick={() => focusDisplay(BLADES.yourDetails)}
    >
      <div className="account-info__wrapper">
        <div className="container pr-lg-5">
          <div className="row col-lg-10 col-md-12">
            <div className="col-12">
              <h3>{accountInfoTitle}</h3>
              <div dangerouslySetInnerHTML={sanitize(accountInfoDesc)} />
            </div>
            <div
              className="col-12"
            >
              <div className="d-flex my-3 info-container p-2">
                <div>
                  <Icon
                    className="mr-1"
                    iconClassName=""
                    screenreader="Screenreader text"
                    symbol="messageInfo16"
                    type="svgfile"
                  />
                </div>
                <div className="mt-n-1" dangerouslySetInnerHTML={sanitize(accountInfoDesc2)} />
              </div>
            </div>
          </div>
          <form className="row col-12 col-md-6 col-lg-5">
            <div className="col-12">
              <TextField
                label={accountNameLabel}
                name="accountName"
                helptext={accountNameHelpText}
                isValid={accountNameIsValid}
                errormessage={accountNameErrorMsg}
                value={accountName}
                onChange={handleChange}
              />
            </div>
            <div className="col-12">
              <TextField
                label={bsbLabel}
                name="bsb"
                errormessage={bsbErrorMsg}
                maxLength={6}
                isValid={bsbIsValid}
                value={bsb}
                onChange={handleNumberChange}
              />
            </div>
            <div className="col-12">
              <TextField
                label={accountNumberLabel}
                name="accountNumber"
                isValid={accountNumberIsValid}
                errormessage={accountNumberErrorMsg}
                maxLength={9}
                value={accountNumber}
                onChange={handleNumberChange}
              />
            </div>
          </form>
          <div className="col-lg-10 col-md-12 mb-4">
            <Checkbox
              checked={isConsent}
              isValid={isConsent}
              id="isConsent"
              name="isConsent"
              label={consentLabel}
              errormessage={consentErrorMsg}
              onChange={handleCheckbox}
            />
            <hr className="mt-3" />
          </div>
          <div className="col-lg-10 col-md-12">
            <div dangerouslySetInnerHTML={sanitize(accountDetailsDesc)} />
          </div>
          {isLoading && (
            <div className="spinner-container">
              <Spinner isVisible />
            </div>
          )}
          <div className="col-12">
            <ButtonActionDefault
              id={analyticsConstants.ofiAccountInfo}
              className="account-details__button-started mt-4"
              onClick={sendModalData}
            >
              {btnTxt}
            </ButtonActionDefault>
          </div>
        </div>
      </div>
    </Blade>
  );
};

export default accountDetails;
